var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Overview of existing jobs")]),_c('crud-table',{attrs:{"endpoint":"/private/jobs","url-base":"jobs","columns":['id', 'createdAt', 'region', 'profile', 'state', 'actions']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }